<!-- a polaroid pasted on the board: square corners and a tight shadow, as if it lies flat on the board. On hover it lifts off the board a bit. -->
<div
  class="relative flex size-full flex-col p-[5cqw] pt-[3cqw] shadow-[0_0.4cqw_0.8cqw_rgb(0_0_0/0.3),0_0_0.3cqw_rgb(0_0_0/0.15)] transition-shadow duration-150 group-hover:shadow-[0_2cqw_4cqw_rgb(0_0_0/0.3),0_0_0.6cqw_rgb(0_0_0/0.15)]"
  [class]="cardClass()"
>
  @if (pulsing()) {
    <span class="anim-pulse-ring pointer-events-none absolute inset-0 outline-4 outline-amber-500"></span>
  }
  <p class="font-default truncate pb-[3cqw] text-center text-[11cqw] leading-tight font-bold">{{ stop().name }}</p>

  <div class="relative min-h-0 w-full flex-1 overflow-hidden rounded-md">
    <lp-img class="block! size-full" [file]="stop().background" fit="cover" />
    @if (state() === 'LOCKED') {
      <div class="absolute inset-0 grid place-items-center bg-slate-900/30 text-[18cqw] text-white">
        <fa-icon [icon]="faLock" />
      </div>
    }
  </div>

  <!-- the dots and date rows keep their height when empty, so all cards line up -->
  <div class="flex h-[10cqw] items-end justify-center gap-[2.5cqw]">
    @for (done of assignmentsFinished(); track $index) {
      <rid-progress-dot class="size-[6cqw]" [progress]="done ? 'FINISHED' : 'IN_PROGRESS'" [tone]="dotTone()" />
    }
  </div>
  <p class="h-[9cqw] pt-[1.5cqw] text-center text-[7cqw] leading-none font-semibold opacity-75">{{ formattedDate() }}</p>
</div>
